// components/LoginCardSet.js
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Card, Font, Avatar, Logo } from "pepsico-ds";
import AccessRequestFormModal from "./AccessRequestForm";
import image from "../../assets/pepsi.png";
import DeniedModal from "./DeniedModal";
import LoginPepsiSvg from "./LoginPepsiSvg";
import {
  clearDeactivatedUserModalFlag,
  getInitialDeactivatedModalState,
  shouldShowDeactivatedUserModal,
} from "../../utils/deactivatedUserSession";

export default function LoginCardSet({
  switchToInternal,
  switchToExternal,
  handleOpen,
  open,
  handleClose,
  errors,
  setErrors,
  checkBox,
  setCheckBox,
}) {
  const [openModal, setModalOpen] = useState(() =>
    getInitialDeactivatedModalState()
  );
  const [isDeactivated, setIsDeactivated] = useState(() =>
    getInitialDeactivatedModalState()
  );

  useEffect(() => {
    if (shouldShowDeactivatedUserModal()) {
      setIsDeactivated(true);
      setModalOpen(true);
    }
  }, []);

  const handleCloseDeniedModal = () => {
    setModalOpen(false);
    setIsDeactivated(false);
    clearDeactivatedUserModalFlag();
  };

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography
          sx={{
            color: "#02355A",
            textAlign: "center",
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Gilroy-Bold, sans-serif",
            fontSize: "var(--Font-Size-H3, 32px)",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "var(--Line-Height-H3, 44px)",
          }}
        >
          Welcome to the PepsiCo’s Agriculture Experience
        </Typography>
      </Box>

      {[
        {
          onClick: switchToInternal,
          text: "Sign-in using PepsiCo OKTA credentials",
        },
        {
          onClick: switchToExternal,
          text: "Sign-in using External OKTA credentials",
        },
      ].map(({ onClick, text }, i) => (
        <div
          className="login-card-item"
          style={{ width: "100%" }}
          key={i}
          data-testid="login-cards"
        >
          <Card
            border
            ellipsis={false}
            icon={null}
            title={null}
            primaryButtonProps={{
              size: "large",
              text: "Sign in",
              variant: "primary",
              onClick,
            }}
            style={{ textAlign: "center", justifyContent: "center" }}
          >
            <img src={image} style={{ width: "122px" }} />

            <Font
              headingLevel={6}
              style={{ textAlign: "center", fontSize: "18px" }}
            >
              {text}
            </Font>
          </Card>
        </div>
      ))}

      <div className="login-card-item" style={{ width: "100%" }}>
        <Card
          border
          ellipsis={false}
          icon={null}
          title={null}
          primaryButtonProps={{
            size: "large",
            text: "Request access",
            variant: "primary",
            onClick: handleOpen,
          }}
          style={{
            textAlign: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Avatar
            size="medium"
            iconType="person"
            style={{
              background: "var(--Tokens-Background-Layer-03, #B2CAEA)",
              color: "#005CBC",
            }}
          />
          <Font headingLevel={6} style={{ textAlign: "center" }}>
            New to the site?
          </Font>
          <Typography
            sx={{
              color: "var(--Tokens-Text-Primary, #3A3A3A)",
              fontFamily: "Gilroy-Bold",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "var(--Line-Height-H6, 28px)",
            }}
          >
            Click below to request access to site
          </Typography>
        </Card>
      </div>

      <AccessRequestFormModal
        open={open}
        handleClose={handleClose}
        errors={errors}
        setErrors={setErrors}
        checkBox={checkBox}
        setCheckBox={setCheckBox}
      />
      <DeniedModal
        setModalOpen={handleCloseDeniedModal}
        openModal={openModal}
        deactivated={isDeactivated}
      />
    </>
  );
}
